
angular.module('ecrd')
    .component('recordQueriesFilters', {
        controller: 'RecordQueriesFiltersController',
        templateUrl: 'modules/ecrd/components/queries/record-filters/template.html',
        bindings: {
            onFilterQueries: '&',
        },
    });
